/* eslint-disable no-restricted-syntax */
import type { TradingTheme } from '@trading-ui/core';

type ClassValue = string | { [key: string]: boolean } | undefined | null | false;

export namespace ThemeUtils {
  export const generateCSSFromTheme = (theme: TradingTheme) => {
    let cssContent = ':root {\n';

    const generateVars = (prefix: string, obj: Record<string, any>): string => {
      let vars = '';
      for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          vars += generateVars(`${prefix}-${key}`, obj[key]);
        } else if (Array.isArray(obj[key])) {
          for (let index = 0; index < obj[key].length; index += 1) {
            vars += `  --${prefix}-${key}-${index}: ${obj[key][index]};\n`;
          }
        } else {
          vars += `  --${prefix}-${key}: ${obj[key]};\n`;
        }
      }
      return vars;
    };

    cssContent += generateVars('palette', theme.palette);
    cssContent += generateVars('shadows', theme.shadows);
    cssContent += generateVars('shape', theme.shape);
    cssContent += '}\n';

    let styleElement = document.getElementById('theme-variables-style') as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'theme-variables-style';
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = cssContent;
  };

  export const cn = (...args: ClassValue[]): string => {
    const classes: string[] = [];

    args.forEach((arg) => {
      if (!arg) return;

      if (typeof arg === 'string') {
        classes.push(arg);
      } else if (typeof arg === 'object') {
        Object.entries(arg).forEach(([key, value]) => {
          if (value) {
            classes.push(key);
          }
        });
      }
    });

    return classes.join(' ');
  };
}
